var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "order-widget",
      class: { "order-widget--selected": _vm.isSelected },
      style: _vm.state.orderWidgetStyle,
      attrs: { tabindex: _vm.widgetIndex, "data-test-bundle": _vm.widgetIndex },
      on: { click: _vm.onOrderWidgetClick },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("div", { staticClass: "order-widget__inner" }, [
        _c(
          "div",
          { staticClass: "order-widget__body" },
          [
            _vm.widgetItem.highlighted
              ? _c(
                  "div",
                  { staticClass: "order-widget__highlight-header" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.i18n.t("general:top_seller")) +
                        "\n        "
                    ),
                    _c("font-awesome-icon", { attrs: { icon: "star" } }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.state.currentLocation != null
              ? [
                  _vm.widgetItem.cloudUnitType.name === _vm.CLOUD_UNIT_TYPE_SLOT
                    ? _c("order-widget-box-slots", {
                        attrs: {
                          duration: _vm.duration,
                          slots: _vm.units,
                          "formatted-price":
                            _vm.state.currentLocation.formattedPrice,
                          "cloud-unit-type": _vm.widgetItem.cloudUnitType,
                          extras: _vm.widgetItem.extensions,
                        },
                      })
                    : _vm.widgetItem.cloudUnitType.name ===
                      _vm.CLOUD_UNIT_TYPE_RAM
                    ? _c("order-widget-box-ram", {
                        attrs: {
                          duration: _vm.duration,
                          units: _vm.units,
                          "formatted-price":
                            _vm.state.currentLocation.formattedPrice,
                          "cloud-unit-type": _vm.widgetItem.cloudUnitType,
                        },
                      })
                    : _vm._e(),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "order-widget__footer" },
              [
                _c(
                  "div",
                  { staticClass: "bs order-widget__location" },
                  [
                    !_vm.state.hasOtherLocations
                      ? [
                          _c("strong", { staticClass: "text-brand" }, [
                            _vm._v(
                              _vm._s(
                                _vm.i18n.t(
                                  "landingpage:orderwidget.dropdown.title_other_region"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("dropdown-input-element", {
                            staticClass: "order-widget__dropdown",
                            staticStyle: { "margin-bottom": "1.25em" },
                            attrs: {
                              value: _vm.state.selectedItem,
                              default: _vm.state.selectedItem,
                              items: _vm.state.dropdownItems,
                            },
                            model: {
                              value: _vm.state.selectedItem,
                              callback: function ($$v) {
                                _vm.$set(_vm.state, "selectedItem", $$v)
                              },
                              expression: "state.selectedItem",
                            },
                          }),
                        ]
                      : _vm.state.selectedItem != null
                      ? _c(
                          "div",
                          { staticStyle: { "margin-bottom": "1.25em" } },
                          [
                            _c("strong", { staticClass: "text-brand" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.i18n.t(
                                    "landingpage:orderwidget.dropdown.title_other_region"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "location-dropdown__value location-dropdown__value--cursor-default",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.state.selectedItem.title) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c("order-now-button", {
                  staticClass: "order-widget__order-button",
                  attrs: {
                    "button-classes": "button--tiny",
                    units: _vm.units,
                    duration: _vm.duration,
                    "current-location": _vm.state.currentLocation,
                    extras: _vm.widgetItem.extensions,
                  },
                }),
              ],
              1
            ),
          ],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }